"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M12.29 1.9a5.627 5.627 0 0 1 5.336 5.619v2.787h1.016c1.003 0 1.818.814 1.818 1.817v8.166a1.82 1.82 0 0 1-1.818 1.818H5.359A1.82 1.82 0 0 1 3.54 20.29v-8.166a1.82 1.82 0 0 1 1.82-1.817h1.014V7.519A5.626 5.626 0 0 1 12 1.893l.29.006ZM12 13.603a1.805 1.805 0 0 0-.857 3.391v1.54c0 .459.264.846.624.965h.465c.36-.12.626-.506.626-.966v-1.538a1.805 1.805 0 0 0-.858-3.39Zm0-9.711a3.626 3.626 0 0 0-3.626 3.626v2.785h.078v.002h7.096v-.002h.078V7.519A3.626 3.626 0 0 0 12 3.893Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};